import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { TCreateSegmentBody } from 'types/segment';

import { audienceKeys } from './audience.queries';
import { createSegment, getSegment, getSegments } from './audience.requests';

export const useGetSegments = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: audienceKeys.segments(),
    queryFn: getSegments,
  });

  return { segments: data ?? [], isLoading, isError, refetch };
};

export const useGetSegment = (id: string | undefined | null) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: audienceKeys.segment(id ?? ''),
    queryFn: () => getSegment(id as string),
    enabled: !!id,
  });

  return {
    segment: data,
    attributeKeys: data?.attributeKeys ?? [],
    isLoading,
    isError,
  };
};

export const useCreateSegment = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (body: TCreateSegmentBody) => createSegment(body),
    onSuccess: (segment) => {
      queryClient.setQueryData(audienceKeys.segment(segment.id), segment);
      queryClient.invalidateQueries({ queryKey: audienceKeys.segments() });
    },
  });

  return { createSegment: mutateAsync, isPending };
};
